import React, { memo } from "react";

const WayfinderLocationPanel = memo(
  ({
    useCurrentLocation,
    setUseCurrentLocation,
    customLocation,
    handleLocationTypeChange,
    isLoadingLocation,
    isSearchingLocation,
    searchResults,
    showSearchResults,
    handleLocationSelect,
    handleConfirm,
  }) => {
    return (
      <div className="location-panel">
        <h2 className="panel-title">Confirm Your Location</h2>

        <div className="location-options">
          <div className="location-option">
            <div className="location-option-content">
              <div className="location-icon">
                <i className="fas fa-location-dot"></i>
              </div>
              <span className="location-text">Current Location</span>
            </div>
            <input
              type="checkbox"
              checked={useCurrentLocation}
              onChange={(e) => setUseCurrentLocation(e.target.checked)}
              className="location-checkbox"
            />
          </div>

          <div className="custom-location-input">
            <div className="search-icon">
              <i className="fas fa-search"></i>
            </div>
            <input
              type="text"
              placeholder="Search for your location..."
              value={customLocation}
              onChange={handleLocationTypeChange}
              className="location-input"
              disabled={useCurrentLocation}
            />
            {isSearchingLocation && (
              <div className="search-loading">
                <i className="fas fa-spinner fa-spin"></i>
              </div>
            )}

            {/* Search Results Dropdown */}
            {showSearchResults && searchResults.length > 0 && (
              <div className="search-results">
                {searchResults.map((result, index) => (
                  <div
                    key={index}
                    className="search-result-item"
                    onClick={() => handleLocationSelect(result)}
                  >
                    <i className="fas fa-map-marker-alt"></i>
                    <div className="result-details">
                      <div className="result-name">{result.display_name}</div>
                      <div className="result-type">{result.type}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <button
          className="confirm-button"
          onClick={handleConfirm}
          disabled={useCurrentLocation && isLoadingLocation}
        >
          {isLoadingLocation ? "GETTING LOCATION..." : "CONFIRM"}
        </button>
      </div>
    );
  }
);

WayfinderLocationPanel.displayName = "WayfinderLocationPanel";

export default WayfinderLocationPanel;
